









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class SubscriptionView extends Vue {
  public items: Common.Subscription[] = new Array(0);
  public params: Common.SubscriptionQuery = new Common.SubscriptionQuery();
  public exportQuery = new Common.ExportQuery('サブスクリプション', this.params);
  public sortOptions: any = [{ value: 'tenantId', text: 'テナントID' },{ value: 'tenantName', text: 'テナント名称' }];
  @Prop() public tenantId:string;

  public created(){
    if (this.tenantId) this.params.tenantId = this.tenantId;    
  }
  
  public showTenant(tenantId:string){
      this.$router.push(String.format('/project/tenant?tenantId={0}',tenantId));
  }  
}
